var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"password-reset-request-container"},[_c('div',{staticClass:"pepper-badge"},[_c('img',{attrs:{"src":_vm.pepperBadgeUrl}})]),_c('div',{staticClass:"reset-password-title",attrs:{"tabindex":"0","role":"definition"}},[_vm._v("forgot password")]),_c('cmg-password-reset')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }